'use client';

export type BaseEventMeta = {
    currentUrl: URL;
    referrer?: URL;
};

export type BuildBaseMetaParams = {
    explicitUrl?: string; // override window.location.href if needed
    explicitReferrer?: string; // override document.referrer if needed
};

function safeParseURL(input?: string | null): URL | undefined {
    if (!input) return undefined;
    try {
        return new URL(input);
    } catch {
        return undefined;
    }
}

function computeCurrentUrl(explicitUrl?: string): URL {
    const href = explicitUrl || window.location?.href || 'about:blank';
    return new URL(href);
}

function computeReferrer(explicitReferrer?: string): URL | undefined {
    if (explicitReferrer) return safeParseURL(explicitReferrer);
    if (document.referrer) return safeParseURL(document.referrer);

    try {
        const topRef = (window.frames?.top as Window | undefined)?.document?.referrer;
        return safeParseURL(topRef);
    } catch {
        return undefined;
    }
}

export function buildBaseInteractionMeta(params: BuildBaseMetaParams = {}): BaseEventMeta {
    return {
        currentUrl: computeCurrentUrl(params.explicitUrl),
        referrer: computeReferrer(params.explicitReferrer),
    };
}
